exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ds-inline-alert{align-items:center;border-left:.25rem solid var(--ds-color-london-35);box-sizing:border-box;color:var(--ds-color-london-5);display:inline-flex;flex-wrap:wrap;font-family:var(--ds-type-system-sans-lining);font-size:var(--ds-type-scale-0);font-weight:400;line-height:var(--ds-type-leading-lower);min-height:1.5rem;padding:.125rem 0 .125rem .5rem;position:relative}.ds-inline-alert__lede{font-weight:500;margin:0 .25rem 0 0}.ds-inline-alert--error{border-left-color:var(--ds-color-tokyo-55)}.ds-inline-alert--success{border-left-color:var(--ds-color-chicago-55)}.ds-inline-alert--warning{border-left-color:var(--ds-color-singapore-55)}", ""]);

// exports
exports.locals = {
	"ds-inline-alert": "ds-inline-alert",
	"ds-inline-alert__lede": "ds-inline-alert__lede",
	"ds-inline-alert--error": "ds-inline-alert--error",
	"ds-inline-alert--success": "ds-inline-alert--success",
	"ds-inline-alert--warning": "ds-inline-alert--warning"
};